var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","justify-content":"center"}},[_c('div',{style:({ minWidth: _vm.data.grid_width + '%' })},[_c('div',{staticClass:"gridOverflow go-actionIcon ssg fs ssgdim",style:({
      '--itemMinWidth': _vm.data.minimum_tile_width ? _vm.data.minimum_tile_width  + 'px' : 210 + 'px',
      '--gridGap': _vm.data.grid_gap ? _vm.data.grid_gap + 'px': '10px'
      })},_vm._l((_vm.data.tile_buttons),function(item,index){return _c('TileButtonBlock',{key:index,attrs:{"item":item,"data":_vm.data}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }